const isTouchDevice = (() => {
  return (("ontouchstart" in window) ||
    (navigator.maxTouchPoints > 0) ||
    (navigator.msMaxTouchPoints > 0))
})()

const touchTooltipDuration = 2000
const touchAutoCloseTooltip = (instance) => {
  if (isTouchDevice) {
    // Clear existing timer, if any.
    if (instance._autoCloseTimer) {
      clearTimeout(instance._autoCloseTimer)
    }

    instance._autoCloseTimer = setTimeout(() => {
      instance.hide()
      delete instance._autoCloseTimer
    }, touchTooltipDuration)
  }
}

const tooltipOptions = {
  duration: [300, 300],
  delay: [500, 0],
  theme: "translucent",
  content: (element) => {
    return element.dataset.tooltip
  },
  // 'onShow' has a bug on mobile (specifically iOS Safari): it isn't called
  // when tooltips are opened sequentially one after the other.
  // The fix is to use 'onTrigger'.
  onTrigger: (instance, event) => {
    touchAutoCloseTooltip(instance)
  }
}

const selector = "[data-tooltip]:not([data-tooltip=''])"
const tooltipSelector = isTouchDevice ?
  `${selector}:not(a):not([data-tooltip-no-touch])` :
  selector

export default tooltipOptions
export { tooltipSelector }
